import { InjectionToken } from '@angular/core';
import { CastMember } from '@app/core/classes/cast-member';
import { Action, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

import * as fromUser from './user-claims.reducer';
import * as fromCastForm from './cast-form.reducer';
import * as fromCastProfile from './cast-profile.reducer';
import * as fromApp from './app.reducer';

export interface State {
    [fromUser.featureKey]: CastMember;
    [fromCastForm.featureKey]: any;
    [fromCastProfile.featureKey]: any;
    [fromApp.featureKey]: any;
}

export const ROOT_REDUCERS = new InjectionToken<ActionReducerMap<State, Action>>('Root reducers token', {
    factory: () => ({
        [fromUser.featureKey]: fromUser.reducer,
        [fromCastForm.featureKey]: fromCastForm.reducer,
        [fromCastProfile.featureKey]: fromCastProfile.reducer,
        [fromApp.featureKey]: fromApp.reducer
    }),
});

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];
